import CashBook from './CashBook'
import columns from './sideListColumns'
import listCashBooksSettings from './gql/listCashBooksSettings'
import createCashBookSettings from './gql/createCashBookSettings'
import updateCashBookSettings from './gql/updateCashBookSettings'
import getSalesGroup from '../SalesGroups/gql/getSalesGroup'

const sections = t => ([{
	label: t('options_section.strings.cash_book'),
	link: 'kassenbuch',
	listQuery: listCashBooksSettings,
	itemQuery: getSalesGroup,
	createMutation: createCashBookSettings,
	addNewRecord: true,
	requiredFields: ['description', 'shouldAccount', 'haveAccount', 'tax', 'type'],
	typename: 'CashBookSettings',
	columns: columns(t),
	subsections: [{
		link: '',
		component: CashBook,
		updateMutation: updateCashBookSettings
	}]
}])

export default sections
